import { Component } from '@angular/core';
import {BreadcrumbComponent} from "../../components/common/breadcrumb/breadcrumb.component";

@Component({
    selector: 'app-sitemap',
    imports: [
        BreadcrumbComponent
    ],
    templateUrl: './sitemap.component.html',
    styleUrl: './sitemap.component.scss'
})
export class SitemapComponent {

}
